import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes with clsx
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Pathname reduced to the form a route path can be compared against: trailing slashes
 * removed (`/settings/` → `/settings`) and lower-cased. The router trims trailing slashes
 * when it matches a route and matches route paths case-insensitively, but it leaves
 * `location.pathname` exactly as typed — so `/Settings/` reaches the route while a plain
 * `===` against its path fails. The root path stays `/`.
 */
export function normalizeRoutePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '').toLowerCase();
  return trimmed === '' ? '/' : trimmed;
}

/**
 * Get initials from name
 */
export function getInitials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}

/**
 * Capitalize first letter
 */
export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Format employment status for display
 */
export function formatEmploymentStatus(status: string): string {
  return status.split('_').map(capitalize).join(' ');
}

